import '../CSS/Navbar.css'
const Navbar = () => {

    return (
        <nav className="navbar">
            <div className="logo">
                <span className="logo-text">C Compiler</span>
            </div>
        </nav>
    );

};

export default Navbar;